import httpClient from './http-client';

const list = (filter: any): Promise<any> => {
    const params = {
        query: filter
    };

    return httpClient.invoke('profile', 'list', params);
};

const listPermissions = (filter: any): Promise<any> => {
    const params = {
        query: filter
    };

    return httpClient.invoke('profile', 'listPermissions', params);
};

const get = (profileId: string): Promise<any> => {
    const params = {
        query: {
            profileId: profileId
        }
    };

    return httpClient.invoke('profile', 'get', params)
};

const add = (data: any): Promise<any> => {
    const params = {
        data: data
    };

    return httpClient.invoke('profile', 'add', params)
};

const update = (profileId: string, data: any): Promise<any> => {
    const params = {
        query: {
            profileId: profileId
        },
        data: data
    };

    return httpClient.invoke('profile', 'update', params)
};

const remove = (profileId: string): Promise<any> => {
    const params = {
        query: {
            profileId: profileId
        }
    };

    return httpClient.invoke('profile', 'remove', params)
};

export default {
    list,
    listPermissions,
    get,
    add,
    update,
    remove
}